import React, { useState, useEffect } from 'react';
import Dropdown from './widgets/dropdown';
import { useTheme } from '../theme/ThemeContext';
import CloseIconBlack from '../static/images/black_icons/x_icon_black.png';
import CloseIconWhite from '../static/images/x_icon.png';

const CoordinateBox = ({ scatterplot, setScatterPointsCategory, setSelectedIcon, scatterPointsCategory, hasUserSamples }) => {
    const { theme } = useTheme();
    const CloseIcon = theme.name === 'light' ? CloseIconBlack : CloseIconWhite

    const placeholderConvertDict = {
        'tsne': 't-SNE',
        'geo': 'Geographic',
        'pcoa': 'PCoA',
        'umap': 'UMAP',
    }
    const placeholder = placeholderConvertDict[scatterPointsCategory]

    // always show all items, but disable some when user samples are present
    const allItems = ['t-SNE', 'Geographic', 'PCoA', 'UMAP'];
    const disabledItems = hasUserSamples ? ['Geographic', 'PCoA', 'UMAP'] : [];

    const colorBoxStyle = {
        margin: '20px',
        padding: '20px',
        color: '#dadada',
        width: '200px',
        fontFamily: 'Arial',
        backgroundColor: theme.colors.overlay,
        borderRadius: '10px',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        transition: 'all 0.3s ease-in-out',
        overflow: 'display',
    };

    const closeIconStyle = {
        position: 'absolute',
        top: '10px',
        right: '10px',
        width: '20px',
        height: '20px',
        cursor: 'pointer',
    };

    const handleCoordinateSelection = (points) => {
        console.log('points:', points);
        const convertionDict = {
            't-SNE': 'tsne',
            'Geographic': 'geo',
            'PCoA': 'pcoa',
            'UMAP': 'umap',
        }
        const item = convertionDict[points];
        setScatterPointsCategory(item);
    }

    // force t-SNE selection when user samples are present
    useEffect(() => {
        if (hasUserSamples && scatterPointsCategory !== 'tsne') {
            setScatterPointsCategory('tsne');
        }
    }, [hasUserSamples, scatterPointsCategory, setScatterPointsCategory]);

    return (
        <div style={colorBoxStyle}>
            <img
                src={CloseIcon}
                alt="Close"
                style={closeIconStyle}
                onClick={() => setSelectedIcon(null)}
            />
            <h2>Choose map</h2>
            {hasUserSamples && (
                <p style={{
                    fontSize: '12px',
                    color: theme.colors.text,
                    marginBottom: '10px',
                    fontStyle: 'italic'
                }}>
                    Only t-SNE available with user samples
                </p>
            )}
            <Dropdown
                items={allItems}
                onSelect={handleCoordinateSelection}
                placeholder={placeholder}
                disabledItems={disabledItems}
            />
        </div>
    );
}

export default CoordinateBox;